
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punelocalcabbooking() {



    const cardData =
    {
        keyword: 'Pune Local Cab Booking',
        heading: 'Platinum24 Cabs: Pune Local Cab Booking',
        headingDescription: ' Platinum24 Cabs offers convenient Pune Local Cab Booking, perfect for city travel, shopping trips, office commutes, and daily errands. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, clean, and comfortable rides at affordable prices. With professional chauffeurs, punctual pickups, and flexible booking options, we make local travel in Pune stress-free and reliable. Whether you need a quick point-to-point transfer, hourly rental, or full-day cab service, Platinum24 Cabs guarantees 24/7 availability, transparent fares, and dependable service for all your local travel needs in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Natural Heritage Site near Satara, is famous for its seasonal bloom of wildflowers. From August to October, the plateau turns into a colorful carpet of orchids, lilies, and rare species. Nature lovers and photographers flock here for its breathtaking landscapes. The site is carefully protected, ensuring eco-friendly tourism. Misty monsoons make it even more enchanting. Kaas Plateau is Satara’s crown jewel of natural beauty."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched at 3,300 feet, offers panoramic views of Satara city. Built in the 16th century, it played a strategic role in Maratha history. The fort has bastions, gates, and temples like Hanuman and Devi shrines. Trekking up is moderately easy and rewarding with scenic vistas. It is especially popular during monsoon. Ajinkyatara Fort is Satara’s living reminder of Maratha valor."
  },
  {
    "title": "Thoseghar Waterfall",
    "description": "Thoseghar Waterfall near Satara is a breathtaking cascade that plunges from over 1,000 feet. Surrounded by lush green hills, it is one of Maharashtra’s tallest waterfalls. Monsoon transforms it into a thundering natural wonder. Visitors enjoy viewpoints and picnic spots nearby. Photographers capture its majestic flow and misty ambiance. Thoseghar is Satara’s monsoon paradise."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a revered spiritual site, known as the final resting place of Sant Ramdas, spiritual guide of Chhatrapati Shivaji Maharaj. Pilgrims visit for its temples and ashrams, where bhajans and prayers create a divine aura. The fort also offers scenic views of valleys and lakes. Devotees believe visiting here grants peace and blessings. Sajjangad is Satara’s sacred blend of history and spirituality."
  },
  {
    "title": "Koyna Dam & Wildlife Sanctuary",
    "description": "Koyna Dam, built on the Koyna River, is one of India’s largest hydroelectric projects. Surrounded by the Western Ghats, it creates the beautiful Shivsagar Lake. The nearby Koyna Wildlife Sanctuary is home to tigers, leopards, and diverse flora and fauna. Monsoon enhances the greenery and water levels, making it a scenic retreat. Boating and nature walks are popular here. Koyna is Satara’s powerhouse of beauty and energy."
  },
  {
    "title": "Natraj Mandir, Satara",
    "description": "Natraj Mandir in Satara is a unique temple dedicated to Lord Shiva in the form of Nataraja, inspired by the famous Chidambaram temple of Tamil Nadu. Its Dravidian-style architecture and intricate carvings attract devotees and tourists. The temple is serene and spiritually uplifting. Festivals like Mahashivratri draw large crowds. Surrounded by peaceful ambiance, it is ideal for meditation. Natraj Mandir is Satara’s sacred cultural landmark."
  },
  {
    "title": "Kaas Lake",
    "description": "Kaas Lake, located near the famous Kaas Plateau, is a tranquil water body surrounded by greenery. It was originally built as a reservoir for Satara. The calm environment makes it ideal for relaxation and photography. Migratory birds can be spotted during certain seasons. Tourists often combine a visit with the flower valley. Kaas Lake is Satara’s peaceful natural retreat."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description": "Chalkewadi Windmill Farms, near Thoseghar, feature hundreds of giant windmills dotting the hills. It is one of Maharashtra’s largest wind energy projects. The landscape looks surreal, especially during monsoon with mist and waterfalls around. Tourists enjoy scenic drives and photography here. The site is peaceful yet futuristic in appeal. Chalkewadi is Satara’s blend of green energy and natural charm."
  },
  {
    "title": "Jarandeshwar Temple & Caves",
    "description": "Jarandeshwar Temple near Satara is dedicated to Lord Shiva and is located near ancient Buddhist caves. The caves have rock-cut architecture and historical significance. Pilgrims visit the temple for its divine aura and natural setting. The site is surrounded by forests and hills, making it serene. It attracts both history lovers and devotees. Jarandeshwar is Satara’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Yamai Devi Temple, Aundh",
    "description": "Located near Satara, the Yamai Devi Temple at Aundh is an ancient and highly revered shrine. Dedicated to Goddess Yamai, it is an important pilgrimage site in Maharashtra. Devotees climb steps to reach the temple perched on a hilltop. The temple is especially vibrant during Navratri. It also offers panoramic views of the surrounding landscape. Yamai Devi Temple is Satara’s divine abode of faith and devotion."
  }
],



   "services": [
    {
      "name": "Local Cab Booking Pune",
      "description": "Easily book your local cab in Pune with our seamless Local Cab Booking service. Whether it’s a quick ride to work, a visit to friends, or running errands, our platform provides instant cab availability, competitive pricing, and hassle-free booking options that fit your schedule and budget perfectly. Enjoy timely pickups and safe travel within the city limits."
    },
    {
      "name": "Pune Local Taxi Service",
      "description": "Our Pune Local Taxi Service offers reliable and efficient transportation across the city. With a fleet of clean, well-maintained vehicles and professional drivers, we ensure your daily commute or leisure travel around Pune is comfortable, affordable, and punctual, no matter the time of day."
    },
    {
      "name": "Book Local Taxi Pune",
      "description": "Book Local Taxi Pune for quick, convenient, and budget-friendly rides anywhere within Pune. Our user-friendly booking platform allows you to reserve taxis on-demand or schedule rides in advance, making your local travel smooth and stress-free with verified drivers and transparent fares."
    },
    {
      "name": "Pune Local Cab Hire",
      "description": "Hire a local cab in Pune for short trips, errands, or daily commutes with ease. Our Pune Local Cab Hire service offers flexible packages tailored to your needs, whether for single rides or hourly rentals, ensuring affordable rates and dependable service for all kinds of city travel."
    },
    {
      "name": "Affordable Local Taxi Pune",
      "description": "Affordable Local Taxi Pune focuses on providing economical travel solutions for residents and visitors alike. Experience safe and comfortable rides around the city without stretching your budget. We emphasize transparent pricing and timely service, helping you get where you need to go without extra costs."
    },
    {
      "name": "Pune Local Taxi Booking Online",
      "description": "Reserve your Pune Local Taxi conveniently online using our easy-to-navigate platform. With instant confirmation, fare estimates, and real-time tracking, Pune Local Taxi Booking Online ensures you have a hassle-free experience from booking to drop-off, perfect for tech-savvy commuters."
    },
    {
      "name": "Pune Local Cab with Driver",
      "description": "Enjoy the convenience of Pune Local Cab with Driver service, where experienced and courteous chauffeurs handle your travel around the city, allowing you to relax or focus on your work during transit. Ideal for business travelers and tourists seeking comfort and professionalism."
    },
    {
      "name": "Pune Local Taxi Fare",
      "description": "Get upfront and transparent Pune Local Taxi Fare details before you book. Our competitive pricing structure ensures no hidden costs, helping you plan your local travel budget accurately. Enjoy affordable rides without compromising on safety or service quality."
    },
    {
      "name": "Local Taxi Service Near Me Pune",
      "description": "Find a Local Taxi Service Near Me in Pune instantly with our wide network of cabs spread across the city. No matter where you are, get quick access to nearby taxis with prompt pickups, ensuring you’re never stranded or delayed during your daily commute or casual outings."
    },
    {
      "name": "Pune Local City Taxi",
      "description": "Travel across Pune hassle-free with Pune Local City Taxi service. Perfect for navigating busy streets, traffic hotspots, and popular destinations, our local city taxis are well-suited for both quick trips and leisurely drives around the cultural and commercial hubs of Pune."
    },
    {
      "name": "Local Cab Deals Pune",
      "description": "Take advantage of exclusive Local Cab Deals Pune that offer discounted rates, special packages, and seasonal offers. Whether you’re a frequent traveler or planning multiple rides, our deals make local travel economical and accessible for everyone."
    },
    {
      "name": "Pune Local Taxi for Airport",
      "description": "Avail Pune Local Taxi for Airport service to ensure timely pickups and drop-offs at Pune Airport. Our reliable airport taxis track flight schedules, provide comfortable luggage space, and maintain punctuality so you never miss a flight or face delays upon arrival."
    },
    {
      "name": "Pune Local Taxi for Sightseeing",
      "description": "Explore Pune’s top attractions and hidden gems with Pune Local Taxi for Sightseeing. Our knowledgeable drivers can also assist with local insights while providing comfortable rides to popular tourist spots, heritage sites, and leisure destinations within the city."
    },
    {
      "name": "Pune Local Taxi Packages",
      "description": "Choose from a variety of Pune Local Taxi Packages tailored for different travel needs, including hourly rentals, full-day city tours, and multi-ride discounts. These packages are designed to offer convenience, flexibility, and cost savings for regular commuters and tourists alike."
    },
    {
      "name": "Pune Local Taxi Service 24x7",
      "description": "Our Pune Local Taxi Service 24x7 ensures you have access to reliable and safe transportation at any hour, day or night. Whether it’s early morning appointments, late-night emergencies, or weekend outings, our round-the-clock cabs are always ready to serve you with professional drivers and clean vehicles."
    }
  ],
  "tableData": [
    ["Local Cab Booking Pune", "Pune Local Taxi Service"],
    ["Book Local Taxi Pune", "Pune Local Cab Hire"],
    ["Affordable Local Taxi Pune", "Pune Local Taxi Booking Online"],
    ["Pune Local Cab with Driver", "Pune Local Taxi Fare"],
    ["Local Taxi Service Near Me Pune", "Pune Local City Taxi"],
    ["Local Cab Deals Pune", "Pune Local Taxi for Airport"],
    ["Pune Local Taxi for Sightseeing", "Pune Local Taxi Packages"],
    ["Pune Local Taxi Service 24x7", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Convenient Pune Local Cab Booking",
      "WhyChoosedescription": "Platinum24 Cabs makes local cab booking in Pune quick and hassle-free with easy online options."
    },
    {
      "WhyChooseheading": "Affordable Rates for Local Travel",
      "WhyChoosedescription": "Enjoy budget-friendly prices for all your local rides within Pune city."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune City",
      "WhyChoosedescription": "Our drivers know Pune’s routes well, ensuring timely and smooth rides."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Hourly or One-Way Trips",
      "WhyChoosedescription": "Choose from hourly packages or point-to-point rides to suit your schedule."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Assistance",
      "WhyChoosedescription": "Our dedicated team is available anytime to help with bookings and queries."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and more based on your group size and comfort."
    },
    {
      "WhyChooseheading": "Real-Time Cab Tracking for Peace of Mind",
      "WhyChoosedescription": "Track your cab live through our app or website to stay updated on your ride status."
    }
  ]





































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer local cab booking services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides convenient and reliable local cab booking services throughout Pune city.',
    },
    {
        question: 'How can I book a local cab in Pune with Platinum24 Cabs?',
        answer: 'You can book a local cab easily through our website, mobile app, or by calling our customer support team.',
    },
    {
        question: 'What types of vehicles are available for local cab rides in Pune?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your local travel needs.',
    },
    {
        question: 'Are local cabs available on short notice in Pune?',
        answer: 'Yes, we strive to provide quick and timely local cab services, often within minutes depending on availability.',
    },
    {
        question: 'Can I book a local cab for hourly rental in Pune?',
        answer: 'Yes, we offer hourly rental packages allowing you to use the cab as per your schedule within Pune.',
    },
    {
        question: 'Are the local cabs sanitized and safe to travel in Pune?',
        answer: 'Absolutely, all vehicles are regularly sanitized, and drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Can I customize pickup and drop locations for local rides in Pune?',
        answer: 'Yes, you can specify any pickup and drop-off points within Pune city as per your convenience.',
    },
    {
        question: 'Are local cab services available 24x7 in Pune?',
        answer: 'Yes, our local cab services operate round the clock to cater to your travel needs anytime.',
    },
    {
        question: 'What are the payment options for local cab bookings?',
        answer: 'We accept multiple payment options including cash, credit/debit cards, and digital wallets.',
    },
    {
        question: 'Does Platinum24 Cabs offer corporate local cab services in Pune?',
        answer: 'Yes, we provide customized local cab solutions for corporate clients with priority service and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prakash Deshmukh',
        feedback: 'Booking a local cab in Pune was very easy and the service was prompt. Highly recommend Platinum24 Cabs.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Radhika Pawar',
        feedback: 'The local cab I booked was clean, comfortable, and the driver was very courteous. Great experience overall.',
        rating: 5,
    },
];




















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneLocalCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Pune local cab booking service offering affordable local taxi hire with professional drivers, available 24x7 for airport transfers, sightseeing, and more.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Local Cab Booking Pune",
    "Pune Local Taxi Service",
    "Book Local Taxi Pune",
    "Pune Local Cab Hire",
    "Affordable Local Taxi Pune",
    "Pune Local Taxi Booking Online",
    "Pune Local Cab with Driver",
    "Pune Local Taxi Fare",
    "Local Taxi Service Near Me Pune",
    "Pune Local City Taxi",
    "Local Cab Deals Pune",
    "Pune Local Taxi for Airport",
    "Pune Local Taxi for Sightseeing",
    "Pune Local Taxi Packages",
    "Pune Local Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Pune Local Cab Booking | Reliable Local Taxi Service Pune</title>
  <meta
    name="description"
    content="Reliable Pune local cab booking service offering affordable local taxi hire with professional drivers, available 24x7 for airport transfers, sightseeing, and more."
  />
  <meta
    name="keywords"
    content="Local Cab Booking Pune, Pune Local Taxi Service, Book Local Taxi Pune, Pune Local Cab Hire, Affordable Local Taxi Pune, Pune Local Taxi Booking Online, Pune Local Cab with Driver, Pune Local Taxi Fare, Local Taxi Service Near Me Pune, Pune Local City Taxi, Local Cab Deals Pune, Pune Local Taxi for Airport, Pune Local Taxi for Sightseeing, Pune Local Taxi Packages, Pune Local Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneLocalCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punelocalcabbooking;